<template>
  <div class="step-b">
    <div class="row no-gutters">
      <div class="alert alert-danger" v-if="getBirthdate === ''">
        {{ $t("birthdateError") }}
      </div>
      <div class="col-3">
        <div class="myfield">
          <input
            type="number"
            id="day"
            v-model="day"
            :placeholder="$t('day')"
            min="1"
            max="31"
            @keyup.enter="trySubmit"
          />
          <label for="day">{{ $t("day") }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="myfield">
          <select v-model="month" id="month" @keyup.enter="trySubmit">
            <option
              v-for="(option, index) in $moment.months()"
              :key="option"
              :value="index + 1"
            >
              {{ option }}
            </option>
          </select>
          <label for="month">{{ $t("month") }}</label>
        </div>
      </div>
      <div class="col-3">
        <div class="myfield">
          <input
            type="number"
            id="year"
            v-model="year"
            :placeholder="$t('year')"
            :min="$moment().year() - 100"
            :max="$moment().year()"
            @keyup.enter="trySubmit"
          />
          <label for="year">{{ $t("year") }}</label>
        </div>
      </div>
    </div>
    <div class="col-12 px-2 mb-3 mt-4 scrollto">
      <div class="row">
        <div class="alert alert-danger" v-if="getGender === ''">
          {{ $t("genderError") }}
        </div>
        <a
          href="#"
          @click.prevent="gender = 'male'"
          class="col text-center shadow border mx-3 p-3 gender-wrapper"
          :class="{ active: gender === 'male' }"
        >
          <span class="d-block d-md-inline"><MaleIcon></MaleIcon></span>
          {{ $t("male") }}
        </a>
        <a
          href="#"
          @click.prevent="gender = 'female'"
          class="col text-center shadow border mx-3 p-3 gender-wrapper"
          :class="{ active: gender === 'female' }"
        >
          <span class="d-block d-md-inline"><FemaleIcon></FemaleIcon></span>
          {{ $t("female") }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import MaleIcon from '@/components/Icons/Male'
import FemaleIcon from '@/components/Icons/Female'
export default {
  components: {
    MaleIcon,
    FemaleIcon
  },
  data () {
    return {
      gender: '',
      day: null,
      month: null,
      year: null
    }
  },
  computed: {
    ...mapGetters({
      try: 'register/try',
      getGender: 'register/gender',
      getBirthdate: 'register/birthdate',
      errors: 'register/errors'
    })
  },
  watch: {
    try () {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      query.gender = this.gender
      query.birthdate = ''
      if (this.day && this.month && this.year) {
        const date = `${this.year}-${this.month}-${this.day}`
        query.birthdate = this.$moment(date).format('YYYY-MM-DD')
      }
      this.$router
        .push({
          path: '/register',
          query: query
        })
        .catch(() => {})
    }
  },
  mounted () {
    this.gender = this.getGender
    if (this.getBirthdate) {
      const bd = this.$moment(this.getBirthdate)
      this.year = bd.year()
      this.month = bd.format('M')
      this.day = bd.format('D')
    }
    // this.birthdate = this.getBirthdate
  },
  methods: {
    ...mapMutations({
      trySubmit: 'register/trySubmit'
    })
  }
}
</script>
<style lang="scss">
.step-b {
  .gender-wrapper {
    text-decoration: none;
    transition: all 0.2s;
    &.active {
      background: #3c88ff;
      color: #fff;
    }
    &:hover {
      text-decoration: none;
    }
    svg {
      height: 32px;
      margin-bottom: 0.5em;
      padding: 0 0.5em;
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "gender": "სქესი",
    "male": "მამრობითი",
    "female": "მდედრობითი",
    "day": "დღე",
    "month": "თვე",
    "year": "წელი",
    "birthdateError": "გთხოვთ შეიყვანოთ დაბადების თარიღი",
    "genderError": "გთხოვთ აირჩიოთ სქესი"
  },
  "en": {
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "day": "Day",
    "month": "Month",
    "year": "Year",
    "birthdateError": "Please fill your birth date",
    "genderError": "Please fill your gender"
  }
}
</i18n>
